// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingScreen_container___kEYk","entry":"LoadingScreen_entry__34uZo","text":"LoadingScreen_text__iwmTb"};